import controller from './event-detail.controller';
import templateBase from './views/event-detail.view.html';
import templateAD from './views/event-detail.adaptative.html';

let EventDetailComponent = {
  template:changeTemplate,
  controller,
  bindings : {
    shCtrl : '<',
    eventId: '@'
  }
};

function changeTemplate() {
  if(__env.adaptative){
    return templateAD;
  } else {
    return templateBase;
  }
}

export default EventDetailComponent;



// WEBPACK FOOTER //
// ./www/components/catalog/events/event-detail/event-detail.component.js